import * as yup from 'yup';

// Email checks shared by the sign-in window's forms and the installed app's steps
export const emailRule = (copy) =>
  yup
    .string()
    .trim()
    .required(copy('validation.emailRequired'))
    .email(copy('validation.emailInvalid'));
